import React from 'react'

import { removeNullValues } from '../utils/utils'
import { ANALYTICS_SERVICE_EVENTS } from './constants'
import { dispatchAnalyticsEvent } from './trackSegmentEvent'

type AnalyticsParams = {
  key?: string
  label?: string
  value: string | number | boolean | null
}

const sendAnalytics = ({ key, label, value }: AnalyticsParams) => {
  dispatchAnalyticsEvent({
    serviceEventName: ANALYTICS_SERVICE_EVENTS.VALUE_CHANGED,
    serviceProperties: {
      key: key,
      label: label || key,
      value,
    },
    sendSegmentEvent: false,
  })
}

export function withInputAnalytics(
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  analyticsKey?: string,
  label?: string
): (event: React.ChangeEvent<HTMLInputElement>) => void {
  return function (event) {
    sendAnalytics({
      key: analyticsKey || event.target.name,
      label,
      value: event.target.value,
    })

    onChange(event)
  }
}

export function withDropdownAnalytics<T extends { value: string | number }>(
  onChange: (option: T | null) => void,
  analyticsKey?: string,
  label?: string
): (option: T | null) => void {
  return function (option) {
    sendAnalytics({
      key: analyticsKey || 'dropdown',
      label,
      value: option?.value ?? null,
    })

    onChange(option)
  }
}

export function withFormAnalytics(onSubmit: (formData: any) => any) {
  return async function (formData: any) {
    const data = await onSubmit(formData)

    const shouldSendSegmentEvent = Boolean(data?.eventId)
    const segmentEventName = data?.eventName
      ? data?.eventName
      : ANALYTICS_SERVICE_EVENTS.VALUE_SUBMITTED

    dispatchAnalyticsEvent({
      segmentEventName,
      segmentProperties: removeNullValues({
        producerCount: data?.agent?.producerCount,
        policyCount: data?.agent?.policyCount,
        role: data?.agent?.role,
        license: data?.agent?.license,
        client: data?.agent?.client,
        lastName: data?.userData?.name,
        cancellationReason: data?.cancellationReason,
        module: data?.module,
        email: data?.userData?.email,
        campaignName: data?.campaign,
        formType: data?.formType,
        triedToEditAnswers: data?.triedToEditAnswers,
      }),
      serviceEventName: ANALYTICS_SERVICE_EVENTS.VALUE_SUBMITTED,
      serviceProperties: {
        ...data,
      },
      sendSegmentEvent: shouldSendSegmentEvent,
    })
  }
}
